import * as React from "react";
import {connect} from "react-redux";
import {
    getProducts, getCirclesAPI,
    getPictures
} from '../actions'
import {Avatar, Button, Horizontal, Image, Text, Vertical, NetImage} from "../../../components/index";
import * as ActionTypes from '../ActionTypes'
import {downloadApp} from '../utils'
import {like} from '../apis'
import {imageCut} from '../../../components/Image'
import UserInfoView from './UserInfoView'
import CircleView from './CircleView'


const Header = ({userInfo, onLikePress}) => <Vertical className={'header'}>


    {userInfo.topBanner ? <NetImage source={{uri: userInfo.topBanner}}
                                    style={styles.bg}
                                    resizeMode='cover'/> :
        <Image source={require('../assets/icon_user_bg.png')}
               style={styles.bg}
               resizeMode='cover'/>}
    <Image source={require('../assets/dark.png')}
           style={styles.bg}
           resizeMode='cover'/>

    <div className={'avatar'}>
        <Avatar source={{uri: userInfo.avatar}} diameter={70}/>
    </div>
    <Text className={'nickname'}>{userInfo.nickname}</Text>

    <div className={'likeBtn'} onClick={onLikePress}><Image source={require('../assets/ic_hot_like.png')}
                                                            style={{
                                                                width: 14,
                                                                height: 14,
                                                                marginRight: 4,
                                                            }}/>点赞
    </div>
    <Horizontal className={'countContainer'}>
        <Vertical className={'item'}>
            <Text className={'count'}>{userInfo.following_count}</Text>
            <Text className={'label'}>关注</Text>
        </Vertical>
        <Vertical className={'item'}>
            <Text className={'count'}>{userInfo.follower_count}</Text>
            <Text className={'label'}>粉丝</Text>
        </Vertical>
        <Vertical className={'item'}>
            <Text className={'count'}>{Math.floor(userInfo.hot)}</Text>
            <Text className={'label'}>人气</Text>
        </Vertical>
        <Vertical className={'item'}>
            <Text className={'count'}>{userInfo.like}</Text>
            <Text className={'label'}>点赞</Text>
        </Vertical>
    </Horizontal>

    {userInfo.companyInfo ? <div style={{
            zIndex: 999
        }} onClick={this._goShop}>
            <Horizontal style={styles.shopImgBg}>
                <NetImage
                    source={{uri: userInfo.companyInfo.logo}}
                    style={infoStyle.comLogo}/>
                <Vertical>
                    <Text style={infoStyle.comName}>{userInfo.companyInfo.name}</Text>
                    <Text style={infoStyle.comAdd}>{userInfo.companyInfo.address}</Text>
                </Vertical>
                <Vertical style={{flex: 1}}/>
                <Image resizeMode={'contain'}
                       source={require("../assets/renqi.png")}
                       style={{
                           width: 4,
                           height: 7,
                           tintColor: '#fff',
                           marginRight: 15,
                       }}/>
            </Horizontal>
        </div> :
        <div style={{
            zIndex: 999
        }} onClick={this._goShop}>
            <Horizontal style={styles.shopImgBg}>
                <Image
                    source={require("../assets/icnon_dianou.png")}
                    style={infoStyle.comLogo}/>
                <Text style={infoStyle.comName}>{'该纹身师还未加入任何店铺'}</Text>
            </Horizontal>
        </div>}
    {/*<Text className={'companyName'}>{userInfo.company.name}</Text>*/}

</Vertical>;

class HomeScreen extends React.Component {

    loadMoreLock = true;
    state = {
        inited: false,
        index: 1,
        showLikeModal: false,
        selectTag: null,//作品集tag //null 是全部
    };

    componentDidMount() {
        this.init()
        window.addEventListener('scroll', this.handleScroll);
    }


    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = async (e) => {
        const dEnd = (document.body.offsetHeight - window.scrollY) - window.screen.height
        if (dEnd < 20) {
            await this.loadMore()
        }
    };

    async init() {
        if (this.props.products && this.props.products.length) {
            this.loadMoreLock = false;
            window.scrollTo(0, this.props.position)

        } else {
            await this.props.getProducts(this.state.selectTag);
            this.loadMoreLock = false;
        }
    }

    async loadMore() {

        if (this.state.index === 1) {
            await this.props.getProducts(this.state.selectTag, true);
        } else if (this.state.index === 2) {
            await this.props.getPictures(true);
        } else if (this.state.index === 3) {
            await this.props.getCircles(true);
        }

    }


    clickTag = async(tag) => {
        this.setState({selectTag: tag})
        await this.props.getProducts(tag);
    };

    toDetail = (product) => {
        this.props.savePosition(window.scrollY);
        this.props.history.push('/' + this.props.userInfo.userId + '/detail/' + product._id)
    };
    toProductionType = () => {
        this.props.savePosition(window.scrollY);
        this.props.history.push('/' + this.props.userInfo.userId + '/productionType')
    };
    toPictureDetail = (picture) => {
        this.props.savePosition(window.scrollY);
        location.href = 'http://m.wenshendaka.com/n/pictures#/' + picture._id
    };

    toCircleDetail = (feed) => {
        this.props.savePosition(window.scrollY);
        location.href = 'http://m.wenshendaka.com/feed_detail/?_id=' + feed._id
    };

    toLike = async () => {
        const res = await like(this.props.userInfo.userId);
        if (res.isOk) {
            this.props.like();
            this.setState({showLikeModal: 1})
        } else {
            this.setState({showLikeModal: 2})
        }
    };

    renderLikeModal() {
        if (this.state.showLikeModal)
            return <div className={'modal'} onClick={() => this.setState({showLikeModal: 0})}>

                <div className={'like_content'} onClick={(e) => e.stopPropagation()}>
                    <div className={'header ' + (this.state.showLikeModal === 1 ? 'success' : 'fail')}/>
                    <div className={'body'} onClick={downloadApp}>
                        <Image source={require('../assets/bg_logo.png')}
                               style={{
                                   width: 100,
                                   height: 15,
                                   top: -8, marginLeft: 100,
                                   backgroundColor: '#fff',
                                   position: 'absolute',
                                   backgroundSize: 'contain'
                               }}/>
                        <div className={'tips'}>
                            百万纹身图案免费下载
                        </div>
                        <div className={'get'}>
                            立即获取 <Image source={require('../assets/ic_arrow.png')}
                                        style={{width: 8, height: 16, float: 'right', marginLeft: 10}}/>
                        </div>
                    </div>
                </div>
            </div>
    }

    render() {
        document.title = this.props.userInfo.nickname + '的作品集';

        return <Vertical className={'portfolio home'}>
            <Header userInfo={this.props.userInfo} onLikePress={this.toLike}/>

            <div className={'tabbar2'}>
                <div className={'tabbar'}>
                    <div className={this.state.index === 0 ? 'item on left' : 'item left'}
                         onClick={() => {
                             this.setState({index: 0})
                         }}>
                        资料
                        {this.state.index === 0 && <div className={'indicator'}/>}
                    </div>
                    <div className={this.state.index === 1 ? 'item on' : 'item'}
                         onClick={async () => {
                             this.setState({index: 1})
                         }}>
                        作品集
                        {this.state.index === 1 && <div className={'indicator'}/>}
                    </div>
                    {/*<div className={this.state.index === 2 ? 'item on' : 'item'}
                         onClick={async () => {
                             await this.props.getPictures();
                             this.setState({index: 2})
                         }}>
                        图集
                        {this.state.index === 2 && <div className={'indicator'}/>}
                    </div>*/}
                    {/*<div className={this.state.index === 3 ? 'item on' : 'item'}
                         onClick={async () => {
                             this.setState({index: 3})
                             await this.props.getCircles();
                         }}>
                        动态
                        {this.state.index === 3 && <div className={'indicator'}/>}
                    </div>*/}
                </div>
            </div>
            {this._renderTabbarBottomView()}
            {this.state.index === 1 && <div className={'list'}>
                {this.props.products.map((product, i) => {
                    return <div key={i} className={'product'}>
                        <Image
                            onClick={() => this.toDetail(product)}
                            source={{uri: imageCut(product.images[0], {width: 150, height: 220})}}
                            className={'img'}/>
                        <Vertical style={styles.imageCountWrapper}>
                            <Text style={styles.title}>{product.title}</Text>
                            <Text style={styles.imageCount}>{product.images.length} 张图</Text>
                        </Vertical>
                    </div>
                })}

                {this.renderDownload()}
            </div>
            }


            {this.state.index === 0 &&
            <UserInfoView data={this.props.userInfo}/>
            }

            {this.state.index === 2 &&
            <div className={'list'}>
                {this.props.pictures && this.props.pictures.map((picture, i) => {
                    return <div onClick={() => this.toPictureDetail(picture)} key={i} className={'product'}>
                        {picture.cover && <Image
                            onClick={() => this.toDetail(picture)}
                            source={{uri: imageCut(picture.cover, {width: 150, height: 220})}}
                            className={'img2'}/>}
                        {!picture.cover && <div
                            className={'img2'}/>}

                        <Image source={require('../assets/top_bottom_cover.png')}
                               style={{
                                   marginTop: -190,
                                   width: '95%',
                                   height: 190,
                                   marginLeft: '5%',
                                   borderRadius: 5,
                               }}/>

                        <Horizontal style={styles.infoView}>
                            <Image source={require('../assets/like.png')} style={styles.heartImage}/>
                            <Text style={styles.recommendText}>{picture.like_count || '0'}</Text>
                            <Vertical style={styles.flex}/>
                            <Vertical style={styles.selectView}>
                                <Text style={styles.selectText}>{picture.pictureCount || '0'}图</Text>
                            </Vertical>
                        </Horizontal>
                        <Vertical style={styles.imageCountWrapper}>
                            <Text style={styles.title}>{picture.title}</Text>
                            <Text style={styles.imageCount}>{picture.pictureCount} 张图</Text>
                        </Vertical>
                    </div>
                })}

                {this.renderDownload()}
            </div>}

            {this.state.index === 3 &&
            <div className={'list'}>
                {this.props.circles && this.props.circles.map((circle, i) => {
                    return <CircleView toCircleDetail={this.toCircleDetail} feed={circle}/>
                })}
            </div>}
            {this.renderLikeModal()}
        </Vertical>
    }

    _renderTabbarBottomView() {

        let userInfo = this.props.userInfo;
        let tabIndex = this.state.index;

        if (tabIndex === 3) { //动态
            return <Vertical style={{
                marginLeft: 15,
            }}>
                <Text style={{
                    fontSize: 16,
                    color: '#212121',
                    marginTop: 15,
                    marginBottom: 2,
                }}>发布条数<Text style={{
                    fontSize: 13,
                    color: '#999',
                }}>（{userInfo.feedNum}）</Text></Text>
            </Vertical>
        } else if (tabIndex === 1) { //作品

            return <Vertical style={{
                paddingTop: 15,
                marginLeft: 15,
            }}>
                <Horizontal style={productStyles.topContainer}>
                    <Text style={{
                        fontSize: 16,
                        color: '#212121',
                        marginBottom: 2,
                    }}>个人作品集<Text style={{
                        fontSize: 13,
                        color: '#999',
                    }}>（{userInfo.productNum}）</Text></Text>
                    <Image
                        source={require('../assets/btn_fenlei_chakan.png')}
                        style={productStyles.btnContainer}
                        onClick={() => this.toProductionType()}/>
                </Horizontal>
                {this._renderProductionType()}
            </Vertical>

        } else if (tabIndex === 2) { //图集

            return <Vertical style={{
                marginLeft: 15,
            }}>
                {userInfo.pictureSet && <Text style={{
                    fontSize: 16,
                    color: '#212121',
                    marginTop: 15,
                    marginBottom: 2,
                }}>个人图集<Text style={{
                    fontSize: 13,
                    color: '#999',
                }}>（{userInfo.pictureSet.setCount + '图集 ' + userInfo.pictureSet.pictureCount + '张图'}）</Text></Text>}
            </Vertical>

        } else {
            return
        }
    }

    _isStartsWithLetter = (str) => {
        let letters = ["A","a","B","b","C","c","D","d","E","e","F","f","G","g","H","h","I","i","J","j","K","k","L","l","M","m","N","n","O","o","P","p","Q","q","R","r","S","s","T","t","U","u","V","v","W","w","X","x","Y","y","Z","z"];
        for (let i=0; i<letters.length; i++) {
            if (str.startsWith(letters[i])) {
                return true
            }
        }
        return false;
    }

    _getWidth = (tag, num) => {
        let width;
        if (this._isStartsWithLetter(tag)) {
            width = tag.length * 7;
        } else {
            width = tag.length * 13;
        }
        width += 10;
        let numWidth = 6;
        if (num < 10) {
            width += numWidth;
        } else if (num < 100) {
            width += numWidth * 2;
        } else if (num < 1000) {
            width += numWidth * 3;
        } else if (num < 10000) {
            width += numWidth * 4;
        } else if (num < 10000) {
            width += numWidth * 5;
        } else if (num < 10000) {
            width += numWidth * 6;
        }
        return width;
    }

    _renderProductionType = () => {
        const {tagList} = this.props;
        const {selectTag} = this.state;
        if (tagList && tagList.length > 0) {
            return (
                <Horizontal style={{marginTop: 20,marginBottom: 10, overflow: 'hidden', overflowX:"scroll"}}>
                    <Horizontal style={{
                        paddingLeft: 18,
                        paddingRight: 18,
                        height: 30,
                        borderRadius: 15,
                        backgroundColor: selectTag == null ? '#fff1ee' : '#f2f3f4',
                        alignItems: 'center'
                    }} onClick={() => this.clickTag(null)}>
                        <Text style={{
                            width: 13 * 2,
                            fontFamily: "PingFangSC-Medium",
                            fontSize: 13,
                            color: selectTag == null ? "#fa4c00" : '#0d0d0e',
                        }}>{'全部'}</Text>
                    </Horizontal>
                    {tagList.map((item, index) => {
                        let width = this._getWidth(item.tag, item.num);
                        return (
                            <Horizontal key={index} style={{
                                paddingLeft: 18,
                                paddingRight: 18,
                                height: 30,
                                borderRadius: 15,
                                backgroundColor: selectTag && item._id == selectTag._id ? '#fff1ee' : '#f2f3f4',
                                marginLeft: 10,
                                alignItems: 'center'
                            }} onClick={() => this.clickTag(item)}>
                                <Text style={{
                                    width: width,
                                    fontFamily: "PingFangSC-Medium",
                                    fontSize: 13,
                                    color: selectTag && item._id == selectTag._id ? "#fa4c00" : '#0d0d0e',
                                }}>{item.tag + ' ' + item.num}</Text>
                            </Horizontal>
                        )
                    })}
                </Horizontal>
            )
        }
    }

    renderDownload2() {
        return <div style={{textAlign: 'center', marginTop: 20, color: '#aaa', fontSize: 13, paddingBottom: 20}}
                    onClick={downloadApp}><span>我也要加入 <span
            style={{color: '#2359a6', textDecoration: 'underline'}}>纹身大咖</span></span>
        </div>
    }

    renderDownload() {
        return <Button className={'download'} onClick={downloadApp}>由纹身大咖APP提供技术支持
            <Image
                source={require('../assets/ic_arrow.png')}
                style={{
                    width: 6,
                    height: 10,
                    marginLeft: 20
                }}/></Button>
    }
}


export default connect((state) => {
    return {
        userInfo: state.app.userInfo,
        products: state.app.list,
        tagList: state.app.tagList,
        circles: state.app.circleList,
        pictures: state.app.piclist,
        position: state.app.position,
    }
}, (dispatch) => {
    return {
        like: () => dispatch({type: ActionTypes.LIKE}),
        savePosition: (position) => dispatch({type: ActionTypes.SAVE_POSITION, position}),
        getProducts: (tag, loadMore = false) => {
            return dispatch(getProducts(tag, loadMore))
        },
        getCircles: (loadMore = false) => {
            return dispatch(getCirclesAPI(loadMore))
        },
        getPictures: (loadMore = false) => {
            return dispatch(getPictures(loadMore))
        }
    }
})(HomeScreen);

const productStyles = {
    topContainer: {
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    btnContainer: {
        width: 83,
        height: 29,
        marginRight: 10
    }
}
const styles = {
    infoView: {
        height: 38,
        marginTop: -38,
        alignItems: 'center',
        width: '95%',
        marginLeft: '5%',
    },
    flex: {
        flex: 1,
    },

    heartImage: {
        width: 11,
        height: 9,
        marginLeft: 10,
        marginRight: 5,
    },

    recommendText: {
        fontSize: 12,
        color: "#ffffff"
    },

    selectView: {
        borderRadius: 2,
        backgroundColor: "#0000004",
        marginRight: 5,
    },

    selectText: {
        fontSize: 12,
        color: "#ffffff",
        padding: 3,
        paddingLeft: 6,
        paddingRight: 0,
    },
    imageCountWrapper: {
        // backgroundColor: 'rgba(0,0,0,0.7)',
        backgroundColor: '#f8f8f7',
        height: 74,
        marginTop: -5,
        width: '95%',
        marginLeft: '5%',
        marginBottom: 15,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
    },
    imageCount: {
        fontSize: 11,
        color: "#717171",
        marginTop: 5,
        marginLeft: 13,
    },
    title: {
        color: '#000000',
        fontSize: 15,
        marginLeft: 13,
        marginTop: 16,
        fontWeight: '500'
    },
    bg: {

        position: 'absolute',
        top: 0,
        height: 291,
        width: '100%',
        overflow: 'hidden',
    },
    shopImgBg: {
        flex: 1,
        width: '94%',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.15)',
        marginLeft: '3%',
        height: 60,
        marginTop: 15,
        borderRadius: 5,
        // backgroundColor: 'rgba(255,255,255,0.5)'
    },
}
const infoStyle = {
    container: {
        backgroundColor: '#fff',
        margin: 15,
        borderRadius: 5,
        borderWidth: 1,
        borderColor: "#eeeeee",
        shadowColor: "rgba(0, 0, 0, 0.1)",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowRadius: 8,
        shadowOpacity: 1,
        elevation: 4,
        paddingBottom: 20,
        marginBottom: 20,
    },

    image: {
        width: 53,
        height: 17,
        borderRadius: 9,
        marginRight: 13,
    },

    company: {
        height: 45,
        width: window.screen.width - 70 - 30 - 30,
        borderRadius: 5,
        backgroundColor: "#f4f4f4",
        alignItems: 'center',
    },

    comLogo: {
        width: 39,
        height: 39,
        borderRadius: 2,
        marginLeft: 10,
        marginRight: 20,
        backgroundColor: '#ddd'
    },

    comName: {
        fontSize: 14,
        color: "#ffffff"
    },

    comAdd: {
        fontSize: 12,
        color: "#d7d7da",
        fontWeight: '200',
        marginTop: 3,
    },

    flex: {
        flex: 1,
    },

    arrow: {
        width: 6,
        height: 11,
        marginRight: 15,
    },

};
const foreignStyles = {
    nickname: {
        marginTop: 15,
        marginBottom: 10,
        color: '#fff',
        fontSize: 17,
        fontWeight: 'bold'
    },
    mailbox: {
        marginBottom: 10,
        color: '#fff',
        fontSize: 13,
    },
    followContainer: {
        width: 47,
        height: 24,
        marginTop: 18,
        borderWidth: 1,
        borderColor: "#ffffff",
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 2,
    },
}



// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/HomeScreen.js